import { useMemo } from 'react';

import Num from '@flipster/utils/num';

import { getBonusRedemptionText } from '../../shared/exec-fee-display';

interface FeeInput {
  tradingFee: string;
  fundingFee: string;
  tradingFeeAqxpRedeemed?: string;
  tradingFeeVoucherRedeemed?: string;
  fundingFeeAqxpRedeemed?: string;
}

export function useFeeCalculations(item: FeeInput) {
  const { tradingFee, fundingFee, tradingFeeAqxpRedeemed, tradingFeeVoucherRedeemed, fundingFeeAqxpRedeemed } = item;

  return useMemo(() => {
    const hasTradingFeeBonusRedemption =
      Num(tradingFeeAqxpRedeemed ?? '0').gt(0) || Num(tradingFeeVoucherRedeemed ?? '0').gt(0);
    const tradingFeeBonusRedemptionText = getBonusRedemptionText(tradingFeeAqxpRedeemed, tradingFeeVoucherRedeemed);

    const hasFundingFeeBonusRedemption = Num(fundingFeeAqxpRedeemed ?? '0').gt(0);
    const fundingFeeBonusRedemptionText = getBonusRedemptionText(fundingFeeAqxpRedeemed);

    const originalTradingFee = Num(tradingFee).multipliedBy(-1).toString();
    const actualTradingFee = hasTradingFeeBonusRedemption
      ? Num(tradingFee)
          .minus(tradingFeeAqxpRedeemed ?? '0')
          .minus(tradingFeeVoucherRedeemed ?? '0')
          .multipliedBy(-1)
          .toString()
      : originalTradingFee;

    const originalFundingFee = Num(fundingFee).multipliedBy(-1).toString();
    const actualFundingFee = hasFundingFeeBonusRedemption
      ? Num(fundingFee)
          .minus(fundingFeeAqxpRedeemed ?? '0')
          .multipliedBy(-1)
          .toString()
      : originalFundingFee;

    return {
      feeCalculations: { originalTradingFee, actualTradingFee, originalFundingFee, actualFundingFee },
      hasTradingFeeBonusRedemption,
      tradingFeeBonusRedemptionText,
      hasFundingFeeBonusRedemption,
      fundingFeeBonusRedemptionText,
    };
  }, [tradingFee, fundingFee, tradingFeeAqxpRedeemed, tradingFeeVoucherRedeemed, fundingFeeAqxpRedeemed]);
}
